export default {
'_.lang.pl.text': 'polski',
'_.lang.en.text': 'english',
'_.lang.de.text': 'deutsch',
'_.lang.es.text': 'español',
'_.lang.it.text': 'italiano',
'_.lang.nl.text': 'nederlands',
'_.lang.ru.text': 'русский',
'_.lang.sk.text': 'slovenský',
'_.lang.cs.text': 'čeština',
'_.lang.uk.text': 'український',
'_.lang.ro.text': 'română',
'_.lang.fr.text': 'français',
'_.lang.hu.text': 'magyar',
'_.socialPoints': 'SocialPoints',
'_.cashPoints': 'CashPoints',
'_.pln': 'PLN',
'_.and': 'e',
'_.loadingSpinnerText': 'Aspetta...',
'pageTimerMax.text': 'Dopo il tempo scaduto ci sarà un passaggio automatico alla pagina successiva.',
'pageTimerMax.timeLeft': 'Tempo rimanente',
'pageTimerMin.text': 'Prima della scadenza del tempo non è possibile andare avanti.',
'pageTimerMin.timeLeft': 'Tempo rimanente',
'pageTimerMin.allowNext': 'Puoi andare avanti',
'survey.registerForm.label.email': 'Email',
'survey.registerForm.label.newsletter': 'Voglio ricevere la newsletter',
'survey.registerForm.label.regulations': 'Accetto la politica sulla privacy e il regolamento',
'survey.registerForm.button.register': 'Registrati',
'survey.registerForm.registered': 'Grazie per la registrazione. Ti è stata inviata una email con il link di attivazione.',
'survey.registerForm.cardHeader': 'Registrati e ricevi punti!',
'survey.registerForm.cardBody': 'Per aver compilato il questionario hai ricevuto/a',
'survey.registerForm.cardBody2': 'I punti verranno aggiunti dopo la registrazione del tuo account su swpanel.pl. Inserisci la tua email e registra un account su swpanel.pl',
'survey.notProperDevice': 'Sfortunatamente, non puoi compilare questo questionario su questo dispositivo.',
'survey.properDevices': 'Il questionario è disponibile sui seguenti dispositivi:',
'survey.device-phone': 'smartphone',
'survey.device-tablet': 'tablet',
'survey.device-desktop': 'computer/laptop',
'nextSurveys.header.seeAlso': 'Vedi anche altri questionari',
'nextSurveys.button.fill': 'Compila',
'question.noContent': 'Nessun contenuto della domanda',
'question.input.placeholder.typeYourAnswer': 'Inserisci una risposta',

'question.conjoint.go': 'Fai clic sul pulsante "Avanti"',
'question.matrix.carousel.go': 'Fai clic sul pulsante "Avanti"',
'question.carousel.prevBtn': 'Affermazione precedente',
'question.carousel.nextBtn': 'Prossima affermazione',

'question.open.email.inputPlaceholder': 'Inserisci l\'indirizzo email',
'question.open.email.emailVerify.sendCode': 'Invia il codice di verifica',
'question.open.email.emailVerify.enderCode': 'Inserisci il codice ricevuto',
'question.open.email.emailVerify.enderCode.inputPlaceholder': 'Inserisci il codice',
'question.open.email.emailVerify.confirm': 'Conferma',
'question.open.email.emailVerify.codeIncorrect': 'Il codice inserito non è corretto',
'question.open.email.emailVerify.codeCorrect': 'Indirizzo email verificato correttamente',
'question.open.email.rodoText': 'The administrator of your personal data is SW Research Sp. z o.o. located at ul. J. Dąbrowskiego 64a, 02-561 Warszawa, Warsaw. For matters related to protecting your personal data and exercising your rights, you can contact the Data Protection Inspector at iod@swresearch.pl. Your personal data will be processed during the survey and accounting documentation for 5 years after the year the survey was completed. Your personal data will be processed for the purpose of participating in opinion surveys, analytical purposes to match our services to the needs of our clients, and for keeping accounting documentation (Article 6 (1) (b) of the GDPR(RODO), Article 6 (1) (f) of the GDPR(RODO), Article 6 (1) (c) of the GDPR(RODO) in connection with Article 86 § 1 of the Tax Ordinance).',

'footer.pauseButton.text': 'Sospendi la compilazione',
'footer.buttonPrev.text': 'Indietro',
'footer.buttonClear.text': 'Cancella',
'footer.buttonNext.text': 'Avanti',
'footer.buttonEnd.text': 'Termina',
'footer.buttonStart.text': 'Inizia questionario',
'question.matrix.nextStatement': 'Prossima affermazione',
'question.matrix.previousStatement': 'Affermazione precedente',
};
